import { apiGet, apiPut } from '../utils/axios';

const base_url = `/management`;

export const getStudents = (id) => {
  return apiGet(`${base_url}/${id}/students`);
};

export const updateOrg = (id, data) => {
  return apiPut(`${base_url}/orgs/${id}`, data);
};
